import { ReactNode } from 'react';
import { BlockInteractionsState } from '../BlockInteractionsTypes';
import { Views } from '../BlockInteractions.utils';

type DefaultViewType = {
  state: BlockInteractionsState;
  children: ReactNode;
};

/**
 * Basically just renders the children if the `primaryView` is set to
 * `default`. Could be a one-liner in `render()` but this way I can phrase
 * this comment :)
 *
 * The crucial difference is that the default view is rendered outside of the
 * `block-interactions__content` div.
 */
export function DefaultView({ state, children }: DefaultViewType) {
  const { primaryView } = state;

  if (primaryView === Views.DEFAULT) {
    return children;
  }
  return null;
}
